export default [
  {
    type: 'FLOAT',
    name: 'time',
    defaultName: 'Time',
  },
  {
    type: 'STRING',
    name: 'media',
    defaultName: 'Media',
  },
  {
    type: 'DOUBLE',
    name: 'value',
    defaultName: 'Value',
  },
  {
    type: 'STRING',
    name: 'key',
    defaultName: 'Key',
  },
  {
    type: 'STRING',
    name: 'device',
    defaultName: 'Device',
  },
  {
    type: 'STRING',
    name: 'account',
    defaultName: 'Account',
  },
  {
    type: 'STRING',
    name: 'profile',
    defaultName: 'Profile',
  },
  {
    type: 'STRING',
    name: 'oS',
    defaultName: 'OS',
  },
  {
    type: 'BOOLEAN',
    name: 'isMobile',
    defaultName: 'Is Mobile',
  },
  {
    type: 'STRING',
    name: 'browser',
    defaultName: 'Browser',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'series',
    defaultName: 'Series',
  },
  {
    type: 'STRING',
    name: 'player',
    defaultName: 'Player',
  },
  {
    type: 'STRING',
    name: 'contentHouse',
    defaultName: 'Content House',
  },
  {
    type: 'STRING',
    name: 'user',
    defaultName: 'User',
  },
  {
    type: 'OBJECT',
    name: 'hashValue',
    defaultName: 'Hash Value',
  },
]
